import React, { useState } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    greeting1: "Hello ",
    greeting2: ", how may I help you?",
    invalid: "Invalid message received",
  },
  ja: {
    greeting1: "こんにちは",
    greeting2: "、どのようにお手伝いできますか？",
    invalid: "無効なメッセージを受信しました",
  },
  es: {
    greeting1: "Hola ",
    greeting2: ", ¿en qué puedo ayudarte?",
    invalid: "Mensaje recibido no válido",
  },
});

const Hellouser = (props) => {
  const userDataStep = props.steps["not_login_2"];

  if (userDataStep && userDataStep.value) {
    const { name } = userDataStep.value;

    if (name) {
      return (
        <div style={{ width: "100%" }}>
          {localizationStrings.greeting1 + name + localizationStrings.greeting2}
        </div>
      );
    } else {
      return <div>{localizationStrings.invalid}</div>;
    }
  } else {
    return <div>{localizationStrings.invalid}</div>;
  }
};

export default Hellouser;
